<template>
  <el-dialog
    :visible.sync="showDialog"
    :before-close="handleClose"
    :width="modalWidth"
    top="20vh"
    append-to-body
  >
    <div class="w-full text-root-2 flex justify-center items-center">
      <div class="md:p-6">
        <span
          style="word-break: normal"
          class="flex justify-center font-bold text-2xl text-center"
          >2 Factor Authentication
        </span>

        <div
          style="word-break: normal"
          class="flex justify-center text-gray-40 my-4 text-center"
        >
          Enter the 6-digit code you see in authenticator app
        </div>
        <span
          class="text-root-4 font-semibold flex justify-center text-sm my-4"
        >
          Enter 6 digit code</span
        >
        <div class="mx-4">
          <el-form
            label-position="top"
            :model="verifyAuthForm"
            ref="verifyAuthForm"
            :rules="rules"
            label-width="80px"
            size="normal"
            @submit.prevent
            @keyup.enter.native="validateForm('verifyAuthForm')"
          >
            <el-form-item prop="code" class="mb-4">
              <el-input
                class="text-xl"
                v-model="verifyAuthForm.code"
                name="code"
                placeholder="******"
                type="text"
                maxlength="6"
              ></el-input>
            </el-form-item>
            <el-form-item class="mb-4 hidden">
              <el-input
                class="text-xl"
                v-model="test"
                name="test"
                placeholder=""
              ></el-input>
            </el-form-item>
            <div class="mt-6 mb-4">
              <div
                class="w-full cursor-pointer border-none bg-primary text-white rounded-3xl p-3.5 text-base font-normal flex items-center justify-center"
                @click="validateForm('verifyAuthForm')"
                :disabled="verifyAuthForm.code.length !== 6"
                :loading="isLoading || isVerifyLoading"
              >
                {{ isLoading || isVerifyLoading ? 'Verifying' : 'Verify' }}
              </div>
            </div>
            <p
              class="flex justify-center font-normal text-sm md:text-sm mt-10 cursor-pointer"
              @click="handleClose"
            >
              cancel
            </p>
          </el-form>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import breakpoints from '@/utils/breakpoints.js'

export default {
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    authState: {
      type: String,
      default: ''
    },
    isVerifyLoading: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      breakpoints,
      isLoading: false,
      test: '',
      rules: {
        code: [
          {
            required: true,
            message: 'Code is required',
            trigger: ['blur', 'change']
          },
          {
            min: 6,
            max: 6,
            message: 'Code must be 6 digits',
            trigger: ['blur', 'change']
          }
        ]
      },
      verifyAuthForm: {
        code: ''
      }
    }
  },
  computed: {
    modalWidth () {
      return breakpoints.lgAndUp ? '30%' : breakpoints.mdAndUp ? '70%' : '90%'
    }
  },
  methods: {
    handleClose () {
      this.isLoading = false
      this.resetForm('verifyAuthForm')
      this.$emit('closeDialog')
    },
    validateForm (form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          this.isLoading = true
          if (this.authState === 'createWithdrawal') {
            this.$emit('verifiedUser', { ...this.verifyAuthForm })
          } else if (this.authState === 'deleteWithdrawal') {
            this.$emit('deleteWithdrawalMethod', { ...this.verifyAuthForm })
          } else if (this.authState === 'initiateWithdrawal') {
            this.$emit('initiateWithdrawalRequest', { ...this.verifyAuthForm })
          } else if (this.authState === 'inviteUser') {
            this.$emit('verifiedUser', { ...this.verifyAuthForm })
          } else if (this.authState === 'reassignUser') {
            this.$emit('confirmedUpdateRole', { ...this.verifyAuthForm })
          } else if (this.authState === 'updatePassword') {
            this.$emit('verifiedUser', { ...this.verifyAuthForm })
            this.$emit('closeDialog')
          } else if (this.authState === 'transferTerminal') {
            this.$emit('verifiedUser', { ...this.verifyAuthForm })
            this.$emit('closeDialog')
          } else if (this.authState === 'commissionSettings') {
            this.$emit('verifiedUser', { ...this.verifyAuthForm })
            this.$emit('closeDialog')
          } else if (this.authState === 'deleteBeneficiary') {
            this.$emit('verifiedUser', { ...this.verifyAuthForm })
            this.$emit('closeDialog')
          } else if (this.authState === 'generateKeyState') {
            this.$emit('generateApiKeys', { ...this.verifyAuthForm })
            this.$emit('closeDialog')
          } else if (this.authState === 'editBeneficiary') {
            this.$emit('saveBeneficiary', { ...this.verifyAuthForm })
          } else if (this.authState === 'createYieldProfileState') {
            this.$emit('createYieldProfile', { ...this.verifyAuthForm })
            this.$emit('closeDialog')
          }
        } else {
          this.$notify.error({
            title: 'Invalid Pin',
            message: 'Please enter a valid pin',
            position: 'top-right'
          })
        }
      })
    },
    resetForm (form) {
      this.$refs[form].resetFields()
    }
  },
  watch: {
    'verifyAuthForm.code': function (newValue) {
      if (newValue.length !== 6) {
        const result = newValue.replace(/\D/g, '').replace(/[^0-9]/g, '')
        this.$nextTick(() => {
          this.verifyAuthForm.code = `${result}`
        })
      } else {
        this.validateForm('verifyAuthForm')
      }
    },
    deep: true
  }
}
</script>

<style scoped>
>>> .el-dialog {
  border-radius: 30px;
  padding: 0px 20px 10px 10px;
}
>>> .el-dialog__body {
  padding: 0px 20px;
}
>>> .el-dialog__wrapper {
  overflow: hidden;
  top: 14px;
}
>>> .el-icon-close:before {
  padding: 25px;
  opacity: 0.9;
  color: #c1c4ca;
}
>>> .el-dialog__headerbtn :hover {
  color: #c1c4ca !important ;
}
>>> .el-input__inner {
  border-radius: 8px;
  letter-spacing: 20px;
  padding-right: 3px;
  text-align: center;
  line-height: 20px;
  font-weight: 600;
  border-color: #c7c8d2;
  height: 48px;
}
</style>
